<div class="content">
    <div class="timeline"
         *ngIf="!(selectedEvent | async)">
        <div class="title"
             data-automation-e2e-selector="title">
            Economic Calendar
            <div class="logo"></div>
        </div>
        <div class="dates"
             data-automation-e2e-selector="dates">
            <a data-automation-e2e-selector="date"
               *ngFor="let date of dates | async; let id = index"
                (click)="setSelectedDate(date)"
                [ngClass]="{'selected': date.isSame(eventsDate | async)}">
                <span data-automation-e2e-selector="today"
                      *ngIf="id === 3 && date.isSame(today, 'day');else formated_date">
                    Today
                </span>
                <ng-template #formated_date>
                    {{date.format('M/D')}}({{letterForDay(date)}})
                </ng-template>
            </a>
        </div>
        <div class="none"
             *ngIf="!(loading | async) && (events | async).length === 0">
            No data available
        </div>
        <div class="none"
             *ngIf="(loading | async)">
            Loading...
        </div>
        <div class="itemListWrapper"
             *ngIf="(events | async).length > 0">
            <ul id="itemListId" 
                class="itemList"
                data-automation-e2e-selector="itemsList">
                <li data-automation-e2e-selector="row"
                    *ngFor="let event of events | async">
                    <muni-gameday-calendar-row
                        [event]="event"
                        [current]="(mostRecentEventId | async) === event.id">
                    </muni-gameday-calendar-row>
                </li>
            </ul>
        </div>
    </div>
    <muni-gameday-event [event]="selectedEvent | async"
               *ngIf="!!(selectedEvent | async)">
    </muni-gameday-event>
</div>